import config from '@/config';
import fetchWrapper from '@/services/fetchWrapper.service';

function getLimitedEditionCollectors(artworkSlug) {
  if (!artworkSlug) {
    throw new Error('artworkSlug is required');
  }

  return fetchWrapper.get(
    `${config.apis.api.url}/artwork/${encodeURIComponent(artworkSlug)}/limited-edition-collectors/`,
    { injectToken: true },
  );
}

export default {
  getLimitedEditionCollectors,
};
